import { Amplify, Auth } from 'aws-amplify'
import $ from 'jquery'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import memoize from 'lodash/memoize'

import * as Model from 'api/model'
import SetInternalLayerVisibility from 'drawer/tabs/layers/utils/SetInternalLayerVisibility'

/**
 * AWS Auth loader
 */
const PoziAuthAWS = memoize(function () {
  // Adapters
  const adapters = {
    /**
     * @api {NA} PoziAuthAWS().init Initialise
     * @apiDescription Pozi wrapper of Amplify auth component
     * @apiGroup AWSAuth
     * @apiName init
     */
    init: function () {
      return init()
    },
    /**
     * @api {NA} PoziAuthAWS().stateChange State change
     * @apiDescription Component to manage logins via AWS cognito.
     * @apiGroup AWSAuth
     * @apiName stateChange
     *
     * @apiParam {String} state signIn | signUp | confirmSignIn | confirmSignUp | forgotPassword | verifyContact | signedIn
     *
     * @apiHeader (Amplify) {Link} Authenticator https://aws.github.io/aws-amplify/media/authentication_guide
     */
    stateChange: function (state) {
      return stateChange(state)
    },
    /**
     * @api {NA} PoziAuthAWS().signedIn A user is signed in
     * @apiDescription Check if a user is signed into AWS
     * @apiGroup AWSAuth
     * @apiName signedIn
     *
     * @apiHeader (Amplify) {Link} Authenticator https://aws.github.io/aws-amplify/media/authentication_guide
     *
     * @apiSuccess {Boolean} state true | false
     */
    signedIn: function () {
      return signedIn()
    },
    signOut: function () {
      return signOut()
    }
  }

  /**
   * Init
   */
  var init = function () {
    const bConfigInState = Model.getState('config', false)
    if (bConfigInState) {
      console.log('Skipping Amplify.configure for auth.js due to config flag')
    } else if (Model.get('config.layout.drawer.tabs.tools.login.amplify.Auth.identityPoolId', '') === '') {
      console.log('Skipping Amplify.configure for auth.js due missing identityPoolId')
    } else {
      try {
        const amplifyConfig = Model.get('config.layout.drawer.tabs.tools.login.amplify', null)
        if (!amplifyConfig) {
          console.log('No amplify config, skip loading AWS amplify... note that IE11 has issues with this module.')
          return
        }
        if (!amplifyConfig.Analytics) {
          amplifyConfig.Analytics = {
            autoSessionRecord: false
          }
        }

        console.log('Amplify.configure for auth.js', amplifyConfig)
        Amplify.configure(amplifyConfig)
        if (signedIn()) {
          stateChange('signedIn')
        }
        // ReactDOM.render(<AuthAWSReact />, document.getElementById('aws-amplify'))
        $('#tools-logout-button-aws-amplify').hide()
      } catch (err) {
        console.error(err)
      }
    }
  }

  var signOut = function () {
    console.log('Amplify PoziAuthAWS.signOut')
    Auth.currentAuthenticatedUser()
      .then(user => {
        console.log('Amplify PoziAuthAWS.signOut: User.', user)

        Auth.signOut()
          .then(data => console.log('Amplify', data))
          .catch(err => console.log('Amplify', err))
      })
      .catch(err => console.log('Amplify', err))
  }

  var stateChange = function (state) {
    console.log('Amplify PoziAuthAWS.stateChange:', state)
    const oldState = Model.get('app.auth.aws.state', '')
    if (state === 'signedIn') {
      if (oldState === 'signedIn') {
        console.log('Amplify .... double trigger on signin...')
      } else {
        $('#tools-logout-button-aws-amplify').show()
        Auth.currentAuthenticatedUser()
          .then(user => {
            const groups = get(user, 'signInUserSession.accessToken.payload["cognito:groups"]', [])
            console.log('Amplify PoziAuthAWS.stateChange: Configure Pozi now the user has signed-in.', user, groups)
            Model.set('app.auth.aws.user', user)
            Model.set('app.auth.aws.groups', groups)
            Model.set('app.LocalDataSourceDetected', true)
            SetInternalLayerVisibility()
            Model.set('app.event.signedin', user)
          })
          .catch(err => console.log('Amplify', err))
      }
    } else {
      console.log('Amplify signing out.')
      signOut()

      /* console.log('Amplify clearing local storage.')
      Object.keys(localStorage)
        .forEach(function (key) {
          if (includes(toLower(key), 'cognito')) {
            localStorage.removeItem(key)
          }
        })
        */
      Model.set('app.LocalDataSourceDetected', false)
      Model.unset('app.auth.aws.user')
      Model.unset('app.auth.aws.groups')
      SetInternalLayerVisibility()
      $('#tools-logout-button-aws-amplify').hide()
    }
    Model.set('app.auth.aws.state', state)
  }

  var signedIn = async function () {
    const user = await Auth.currentAuthenticatedUser().catch(err => console.log('Amplify PoziAuthAWS.signedIn error:', err))
    if (!isNil(user)) {
      // console.debug('Amplify PoziAuthAWS.signedIn user:', user)
      return true
    }
    console.warn('PoziAuthAWS.signedIn failed to get user')
    return false
  }

  // Return adapters (must be at end of adapter)
  return adapters
})

export default PoziAuthAWS
